var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loaded_user)?_c('v-app',[_c('New_Menu'),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }